module.exports = __webpack_public_path__ + "static/media/virisol_4.31f6f783.png";